import React from 'react'
import { Link } from 'react-router-dom'

const CategoryCard = ({ category }) => {
  const imageSrc = category.image?.url
    ? `${process.env.REACT_APP_API_URL}/uploads/products/${category.image.url}`
    : category.full_image || '/assets/images/default_banner.jpg'

  // Calculate minimum product price if available
  const minPrice = category?.products && category.products.length
    ? Math.min(...category.products.map(p => p.price || 0).filter(p=>p>0))
    : (category.min_price || null)

  return (
    <div className="col-lg-4 col-md-6 col-sm-6 col-6 mb-4">
      <Link to={`/products?category=${category._id}`} className="text-decoration-none">
        <div className="card category-card h-100">
          {minPrice && (
            <span className="price-tag">Starts at ₹{minPrice}</span>
          )}
          <img src={imageSrc} alt={category.name} className="card-img-top category-img-contain" />
          <div className="card-body text-center">
            <h5 className="card-title ">{category.name}</h5>
            <p className="text-muted mb-0">{category.product_count ?? category.products?.length ?? 0} products</p>
          </div>
        </div>
      </Link>
    </div>
  )
}

export default CategoryCard 